const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

function nextOccurrence(birthDateStr) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const [, m, d] = birthDateStr.split('-').map(Number)
  const thisYear = new Date(today.getFullYear(), m - 1, d)
  return thisYear < today ? new Date(today.getFullYear() + 1, m - 1, d) : thisYear
}

function daysUntil(date) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return Math.round((d - today) / 86400000)
}

function turningAge(birthDateStr, nextDate) {
  const birthYear = Number(birthDateStr.split('-')[0])
  return nextDate.getFullYear() - birthYear
}

export function BirthdaysPanel({ data }) {
  const birthdays = data?.birthdays ?? []

  const upcoming = birthdays
    .map((b) => {
      const next = nextOccurrence(b.birth_date)
      const days = daysUntil(next)
      return { ...b, next, days, age: turningAge(b.birth_date, next) }
    })
    .filter((b) => b.days <= 60)
    .sort((a, b) => a.days - b.days)

  const [, month, day] = (upcoming[0]?.birth_date ?? '').split('-').map(Number)

  if (upcoming.length === 0) {
    return (
      <div className="flex flex-col h-full items-center justify-center panel-animate-in px-4">
        <div className="text-5xl mb-3">🎂</div>
        <p className="text-gray-400 text-lg text-center">No birthdays in the next 60 days</p>
      </div>
    )
  }

  const featured = upcoming[0]
  const rest = upcoming.slice(1, 4)

  return (
    <div className="flex flex-col h-full px-4 sm:px-8 py-4 sm:py-6 panel-animate-in">
      <p className="text-gray-500 text-xs sm:text-sm font-semibold uppercase tracking-widest mb-4">Birthdays</p>

      {/* Featured — next up */}
      <div className="flex-1 flex flex-col items-center justify-center gap-2">
        <div className="text-5xl sm:text-7xl">
          {featured.days === 0 ? '🎉' : '🎂'}
        </div>
        <p className="text-white text-3xl sm:text-5xl font-bold text-center">{featured.name}</p>
        <p className="text-violet-400 text-base sm:text-xl font-semibold">
          {featured.days === 0
            ? `Happy Birthday! Turning ${featured.age} today!`
            : featured.days === 1
            ? `Tomorrow — turning ${featured.age}`
            : `In ${featured.days} days — turning ${featured.age}`}
        </p>
        <p className="text-gray-500 text-sm sm:text-base">
          {MONTH_NAMES[Number(featured.birth_date.split('-')[1]) - 1]} {Number(featured.birth_date.split('-')[2])}
        </p>
      </div>

      {/* Rest */}
      {rest.length > 0 && (
        <div className="flex gap-4 pt-4 border-t border-white/10 flex-shrink-0">
          {rest.map((b) => (
            <div key={b.id} className="flex-1 text-center">
              <p className="text-white text-sm font-semibold truncate">{b.name}</p>
              <p className="text-gray-500 text-xs mt-0.5">
                {MONTH_NAMES[Number(b.birth_date.split('-')[1]) - 1]} {Number(b.birth_date.split('-')[2])}
              </p>
              <p className="text-gray-400 text-xs mt-0.5">
                {b.days === 0 ? 'Today 🎉' : `${b.days}d`}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
